import { render, staticRenderFns } from "./ResDepartment.vue?vue&type=template&id=4d95e310&scoped=true&"
import script from "./ResDepartment.vue?vue&type=script&lang=js&"
export * from "./ResDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ResDepartment.vue?vue&type=style&index=0&id=4d95e310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95e310",
  null
  
)

export default component.exports